import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BillingDisputeSummary, BillingInvoiceSummary } from '@core/models/stripe-billing.model';
import { StripeService } from '@core/stripe/stripe.service';
import { forkJoin, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 'wai-billing-hub-summary',
  templateUrl: './billing-hub-summary.component.html',
  styleUrls: ['./billing-hub-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BillingHubSummaryComponent implements OnInit {
  public loading = false;
  public invoicesAvailable = false;
  public disputesAvailable = false;
  public invoices: BillingInvoiceSummary[] = [];
  public disputes: BillingDisputeSummary[] = [];
  public loadError: string | null = null;

  constructor(
    private stripeService: StripeService,
    private cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.loadBillingHubData();
  }

  public loadBillingHubData(): void {
    this.loading = true;
    this.loadError = null;
    this.cdr.markForCheck();

    forkJoin({
      invoices: this.stripeService.listBillingInvoices().pipe(catchError(() => of({ available: false, items: [] }))),
      disputes: this.stripeService.listBillingDisputes().pipe(catchError(() => of({ available: false, items: [] }))),
    })
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        }),
      )
      .subscribe({
        next: ({ invoices, disputes }) => {
          this.invoicesAvailable = invoices.available;
          this.disputesAvailable = disputes.available;
          this.invoices = invoices.items.slice(0, 5);
          this.disputes = disputes.items.slice(0, 5);
        },
        error: () => {
          this.loadError = 'Failed to load billing records.';
        },
      });
  }

  public hasAnyData(): boolean {
    return this.invoices.length > 0 || this.disputes.length > 0;
  }
}
